import styled, { css } from "styled-components"
import theme from "../theme"

const InputLabel = styled<
  {
    modal?: boolean
    addMember?: boolean
  },
  "label"
>("label")`
  font-size: 1rem;
  font-weight: normal;
  font-family: ${theme.fonts.tertiary};
  position: absolute;
  top: -25px;
  left: -2%;
  background: ${theme.colors.interactiveBackground};
  transform: none;
  opacity: 1;
  color: ${theme.colors.text};
  padding: 0 2%;
  z-index: 1;
  user-select: none;
  pointer-events: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: left;
  cursor: default;
  text-transform: uppercase;
  letter-spacing: 1px;
  ${(props: any) =>
    props.modal &&
    css`
      color: ${theme.colors.modalText};
      background: ${theme.colors.modalBody};
      background-color: ${theme.colors.modalBody};
    `};
  ${(props: any) => props.addMember && css``};
`

export default InputLabel
